var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9644 6.05602C15.8788 5.78039 15.6512 5.57952 15.3772 5.53791L10.7304 4.83136L8.65229 0.424373C8.52974 0.164532 8.27685 0 8 0C7.7231 0 7.47021 0.164532 7.34771 0.424373L5.26972 4.83131L0.622823 5.53786C0.348835 5.57952 0.121158 5.78039 0.0356152 6.05596C-0.0499274 6.33159 0.0214066 6.63411 0.219697 6.83635L3.58219 10.2661L2.78811 15.11C2.74131 15.3957 2.85348 15.6843 3.07747 15.8546C3.20418 15.951 3.35427 16 3.50509 16C3.62084 16 3.73708 15.9711 3.84352 15.9126L7.99995 13.6258L12.1563 15.9126C12.2634 15.9715 12.3807 15.9995 12.4968 16C12.8981 15.9994 13.2232 15.6588 13.2232 15.2387C13.2232 15.1803 13.2169 15.1233 13.205 15.0686L12.4178 10.2662L15.7803 6.83635C15.9786 6.63411 16.0499 6.33159 15.9644 6.05602Z",
    fill: "#C5C5C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.e3c57604766457a3bb299a8077f005b5.svg";
export { ForwardRef as ReactComponent };